import { ArrowLeftIcon } from "@heroicons/react/outline";
import Link from "next/link";
import { useRouter } from "next/router";
import React from "react";
import { twMerge } from "tailwind-merge";
import { localeTexts } from "@/utils/locale";

export default function Crumbs({
  overrideName,
  currentPageStyle = "",
  breadcrumbs = [],
}) {
  const router = useRouter();
  const locale = router.query.locale || "es-MX";

  return (
    <>
      <button
        className="text-decoration-line: mr-4 flex items-center capitalize underline"
        onClick={() => router.back()}
      >
        <ArrowLeftIcon width={14} height={14} />
        <a className="text-decoration-line: font-semibold capitalize underline decoration-neutral-400 decoration-2 sm:text-[12px] md:text-base ">
          &nbsp;
           {localeTexts[locale]?.common?.back || "Atrás"}&nbsp;
        </a>
      </button>
      {breadcrumbs.map((b, idx) => {
        const hrefWithLocale = `${b.href}?locale=${locale}`;
        return (
          <Crumb
            lastPathStyle={currentPageStyle}
            text={b.text}
            href={b.href}
            key={idx}
            last={false}
            overrideName={overrideName}
            locale={locale}
          />
        );
      })}
    </>
  );
}

function Crumb({ text, href, last = false, overrideName, lastPathStyle, locale }) {
  const className = twMerge(
    "font-semibold capitalize text-neutral-500 sm:text-[12px] md:text-base",
    lastPathStyle
  );
  // Localize text if translation exists
  const localizedText = localeTexts[locale]?.breadcrumbs?.[text] || text;

  if (last) {
    return <p className={className}>{overrideName || localizedText}</p>;
  }

  return (
    <>
      <Link
        className="text-decoration-line: capitalize underline sm:text-[12px] md:text-base"
        href={href}
      >
        &nbsp;
        {localizedText}&nbsp;
      </Link>
      <p className="text-neutral-400 sm:text-[12px] md:text-base"> / </p>
    </>
  );
}
